import React from 'react'

import ReactPlayer from 'react-player/lazy'

const HomeHero = ({data}) => {
  const {backgroundVideo, backgroundImage, title, content, button, subsection1, subsection2} = data
  return (
    <>
      <div className='home-hero'>
        <div className="vid-container">
          <ReactPlayer
            url={backgroundVideo}
            className='react-player'
            width='100vw'
            height='100vh'
            loop={true}
            playing={true}
            volume={0}
            muted={true}
          />
        </div>
        <div className="hero-main-wrapper">
          <div className="hero-main-content">
            {title && (
              <h2>{title}</h2>
            )}
            {content && (
              <div dangerouslySetInnerHTML={{__html: content}}></div>
            )}
            {button && (
              <a className="btn button-solid" href={button.url}>{button.title}</a>
            )}
          </div>
        </div>
        <div className="hero-secondary-wrapper">
          <div className="hero-secondary-content top">
            {subsection1.title && (
              <h3>{subsection1.title}</h3>
            )}
            {subsection1.subtitle && (
              <h5 className="subtitle">{subsection1.subtitle}</h5>
            )}
            {subsection1.content && (
              <div dangerouslySetInnerHTML={{__html: subsection1.content}}></div>
            )}
            {subsection1.button && (
              <a className="btn button-outline" href={subsection1.button.url}>{subsection1.button.title}</a>
            )}
          </div>
          <div className="hero-secondary-content bottom">
            {subsection2.title && (
              <h3>{subsection2.title}</h3>
            )}
            {subsection2.subtitle && (
              <h5 className="subtitle">{subsection2.subtitle}</h5>
            )}
            {subsection2.content && (
              <div dangerouslySetInnerHTML={{__html: subsection2.content}}></div>
            )}
            {subsection2.button && (
              <a className="btn button-outline" href={subsection2.button.url}>{subsection2.button.title}</a>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default HomeHero